import classnames from "classnames";
import {ReactElement} from "react";

import css from "./RadioTabs.module.css";

export interface RadioTabItem {
  title: string | ReactElement;
  className?: string;
  id: string;
}

interface RadioTabsProps {
  className?: string;
  items: RadioTabItem[];
  selectedId: string;
  selectTab: (tab: string) => void;
}

const RadioTabs = ({className, items, selectedId, selectTab}: RadioTabsProps) => (
  <ul
    className={classnames("d-flex p-0 w-100 justify-content-stretch align-items-center gap-3", className)}
    role="tablist"
  >
    {items.map((i, idx) => (
      <li
        key={`${idx}-${i.id}`}
        className={classnames(css.RadioTabItem, "d-inline-block w-100 border rounded rounded-3")}
        onClick={() => {
          selectTab(i.id);
        }}
      >
        <div className="d-flex align-items-center justify-content-between">
          <div>{i.title}</div>
          <input type="radio" className={css.RadioTabItemIndicator} checked={i.id === selectedId} readOnly={true} />
        </div>
      </li>
    ))}
  </ul>
);

export default RadioTabs;
